import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope, faUser } from "@fortawesome/free-solid-svg-icons";
import {
  faYoutube,
  faInstagram,
  faFacebook,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

function Footer() {
  const [loading, setLoading] = useState(false);

  return (
    <footer className="contact">
      <div className="contact-section">
        <div className="contact-details">
          <h2>Let's get in touch!</h2>
          <p>
            Got questions about our Virtual Triage App? Our team is here to
            help. Contact us for quick and friendly support.
          </p>
          <div className="contact-info">
            <p>
              <FontAwesomeIcon
                icon={faPhone}
              />{" "}
              +44 20 3744 6851
            </p>
            <p>
              <FontAwesomeIcon
                icon={faEnvelope}
              />{" "}
              teams@virtualtriage.ai
            </p>
          </div>
          <h3>Connect with us!</h3>
          <div className="social-icons">
            <a href="youtube.com">
              <FontAwesomeIcon
                icon={faYoutube}
              />
            </a>
            <a href="https://www.instagram.com/virtualtriage_/">
              <FontAwesomeIcon
                icon={faInstagram}
              />
            </a>
            <a href="https://www.facebook.com/virtualtriage?mibextid=ZbWKwL">
              <FontAwesomeIcon
                icon={faFacebook}
              />
            </a>
            <a href="https://www.linkedin.com/company/virtualtriage/">
              <FontAwesomeIcon
                icon={faLinkedin}
              />
            </a>
            <a href="https://twitter.com/virtual_triage">
              <FontAwesomeIcon
                icon={faTwitter}
              />
            </a>
          </div>
        </div>

        <div className="contact-form-section">
          <h3>Subscribe for Newsletter!</h3>
          <form className="contact-form" onSubmit={async (e) => {
            e.preventDefault();
            setLoading(true);
            const formData = {
              name: e.target.from_name.value,
              number: e.target.number ? e.target.number.value : '',
              email: e.target.email.value,
              message: 'feature request',
              type: 'contact',
            };

            try {
              const response = await fetch('https://portal.virtualtriage.ca/contact_email', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
              });
              if (!response.ok) {
                throw new Error('Failed to send newsletter subscription');
              }
              alert('Subscription successful!');
            } catch (error) {
              console.error('Error sending subscription:', error);
              alert('There was an error sending your subscription. Please try again later.');
            } finally {
              setLoading(false);
            }
          }}>
            <div className="input-wrapper">
              <FontAwesomeIcon icon={faUser} />
              <input type="text" placeholder="Full Name" name="from_name" />
            </div>
            <div className="input-wrapper">
              <FontAwesomeIcon icon={faEnvelope} />
              <input type="email" placeholder="Email" name="email" />
            </div>
            <button className="footer-submit-button" type="submit" disabled={loading}>
              {loading ? (
                <span className="loader"></span>
              ) : (
                "Submit"
              )}
            </button>
            {loading && (
              <div style={{ textAlign: 'center', marginTop: 10 }}>
                <span className="loader"></span> Sending...
              </div>
            )}
          </form>
        </div>
      </div>
              <div className="footer-bottom">
        <div style={{ display: "flex", gap: "20px", alignItems: "center", flexWrap: "wrap", justifyContent: "center" }}>
          <a
            style={{ color: "white", textDecoration: "none" }}
            href="/policy"
            target="_blank"
          >
            Privacy Policy
          </a>
          <a
            style={{ color: "white", textDecoration: "none" }}
            href="/cookie-policy"
            target="_blank"
          >
            Cookie Policy
          </a>
          <button
            onClick={() => {
              localStorage.removeItem('cookieConsent');
              window.location.reload();
            }}
            style={{ 
              background: "transparent", 
              color: "white", 
              border: "1px solid white", 
              padding: "4px 12px", 
              borderRadius: "4px", 
              cursor: "pointer",
              fontSize: "14px",
              textDecoration: "none"
            }}
          >
            Cookie Settings
          </button>
        </div>
        <p>© 2025 Virtual Triage Healthcare-App</p>
      </div>
    </footer>
  );
}

export default Footer; 